import { render } from "./DietModal.vue?vue&type=template&id=44411dea&scoped=true"
import script from "./DietModal.vue?vue&type=script&lang=js"
export * from "./DietModal.vue?vue&type=script&lang=js"

import "./DietModal.vue?vue&type=style&index=0&id=44411dea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44411dea"]])

export default __exports__